<template>
  <div class="hello flex">
    <div class="left">
      <centerleft></centerleft>
    </div>
    <div class="right">
      <div class="head1 flex">
        <div>下属账号</div>
        <div class="caozuo1">
          <button @click="add">添加</button>
        </div>
      </div>

      <div class="main1">
        <div class="one flex">
          <div class="flex">
            <img class="headImg" :src="'https://yunzhixuanpro.fw366.cn/'+data.teacher.avatar_img">
            <div class="info">
              <div style="width: 400px;">
                <span class="name">{{data.teacher.nickname}}</span>
              </div>
              <div style="width: 400px;">
                <span class="address">{{data.teacher.mobile}}</span>
              </div>
            </div>
          </div>
          <button v-if="data.teacher.checked==1" type="button">当前账号</button>
          <button v-if="data.teacher.checked==0" type="button" @click="change(data.teacher)">切换</button>
        </div>
      </div>
      <div class="main1">
        <div class="one flex" v-for="(item,index) in data.list">
          <div class="flex">
            <img :src='"https://yunzhixuanpro.fw366.cn"+item.avatar_img'>
            <div class="info">
              <div style="width: 400px;">
                <span class="name">{{item.nickname}}</span>
              </div>
              <div style="width: 400px;">
                <span class="address">{{item.mobile}}</span>
              </div>
            </div>
          </div>
          <button v-if="item.checked==1" type="button">当前账号</button>
          <button v-if="item.checked==0" type="button" @click="change(item)">切换</button>
        </div>
      </div>

    </div>

    <el-dialog title="绑定用户" :visible.sync="dialogTableVisible" width="700px">
      <div style="width: 547px;margin: 0 auto;">
        <el-input placeholder="请输入手机号" v-model="keyword">
          <el-button slot="append" icon="el-icon-search" @click="search()">搜索</el-button>
        </el-input>
      </div>
      <div class="list" v-show="list.length!=0">
        <div class="one flex">
          <div class="flex">
            <img :src='"https://yunzhixuanpro.fw366.cn"+list.avatar_img'>
            <div class="info">
              <div>
                <span class="name">{{list.nickname}}</span>
              </div>
              <div>
                <span class="address">{{list.mobile}}</span>
              </div>
            </div>
          </div>
          <button type="button" @click="isshow=true">添加</button>
        </div>
        <div v-show="isshow == true">
          <div class="flex getyzm">
            <el-input v-model="smscode" placeholder="请输入验证码" style="width: 200px;margin-right: 40px;"></el-input>
            <el-button class="yzm" @click="handleAdd(list.mobile)" :disabled="isSend">
              {{second==60?'获取验证码':second+'秒后重发'}}
            </el-button>
          </div>
          <div style="overflow: hidden;">
            <el-button type="primary" style="background-color: #C10B17;border: none;float: left;" @click="handleSure">确定
            </el-button>
          </div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
  import centerleft from '../../components/me/centerleft.vue'
  export default {
    data() {
      return {
        data: [],
        dialogTableVisible: false,
        keyword: '',
        list: [],
        smscode: '',
        second: 60,
        isSend: false,
        isshow: false
      }
    },
    components: {
      centerleft
    },
    created() {
      this.$http.teacherBindList().then(res => {
        this.data = res.data
      })

    },
    methods: {
      /* 切换用户*/
      change(item) {
        console.log(item)
        this.$http.teacherShiftLogin({
          id: item.id
        }).then(res => {
          if (res.code == 200) {
            this.$message.success('切换成功')
            localStorage.clear()
            localStorage.setItem('token', res.data.token)
            this.$http.getUserInfo().then(res => {
              this.userInfo = res.data
              localStorage.setItem('userInfo', JSON.stringify(res.data))
              localStorage.setItem('teacher_show', res.data.teacher_show)
              setTimeout(() => {
                this.$router.push('/personalCenter')
              })

            }, 1000)
          }
        })
      },
      /* 点击发送验证码*/
      handleAdd(tel) {
        this.$http.teacherBindUserRequest({
          mobile: this.list.mobile
        }).then(res => {
          this.isSend = true
          let timer = setInterval(() => {
            this.second--
            if (this.second <= 0) {
              this.isSend = false
              clearInterval(timer)
              this.second = 60
            }
          }, 1000)
          this.$message.success('验证码发送成功')
        })
      },
      /* 点击确定绑定时间*/
      handleSure() {
        if (this.smscod == '') {
          this.$message.error('请输入验证码')
          return
        }
        this.$http.teacherBindUserCheck({
          mobile: this.list.mobile,
          code: this.smscode
        }).then(res => {
          this.$message.success('绑定成功')
          this.$http.teacherBindList().then(res => {
            this.data = res.data
          })
        })
      },
      getCode() {

      },
      search() {
        this.$http.teacherSearchUser({
          mobile: this.keyword
        }).then(res => {
          if (res.code == 200) {
            this.list = res.data
          }

        })
      },
      add() {
        this.dialogTableVisible = true
      }
    }
  }
</script>

<style scoped lang="scss">
  .list {
    width: 547px;
    margin: 0 auto;
    min-height: 100px;
  }

  .getyzm {
    margin: 20px 0;

    input {
      margin-right: 40px;
    }
  }

  .login_main {
    .yzm {
      position: absolute;
      width: 107px;
      height: 37px;
      border: 1px solid #C10B17;
      border-radius: 10px;
      color: #C10B17;
      font-size: 16px;
      background-color: #FFFFFF;
      right: 50px;
    }
  }

  .one {
    justify-content: space-between;

    .info {
      margin: 0 10px;
    }

    cursor: pointer;

    .info1 {
      width: 270px;

      img {
        width: 20px;
        height: 20px;
        margin-top: 16px;
      }
    }

    text-align: left;
    border-bottom: 1px solid #F2F2F2;
    padding-bottom: 17px;
    margin-top: 20px;

    button {
      width: 74px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      font-weight: 400;
      color: #FFFFFF;

    }

    img {
      width: 67px;
      height: 67px;
      border-radius: 50%;
      margin-right: 12px;
    }

    .type {
      margin-top: 22px;
      font-size: 13px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;

      span {
        margin-right: 5px;
      }
    }

    .name {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      margin-right: 29px;
      margin-bottom: 10px;
    }

    .address {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-top: 10px;
    }
  }

  .caozuo {
    text-align: left;

    button {
      width: 58px;
      height: 36px;
      border: none;
      border-radius: 4px;
    }

    & button:nth-child(1) {
      background: #C10B17;
      color: #FFFFFF;
      margin-right: 30px;
    }

    & button:nth-child(2) {
      background: #F0F1F6;
      color: #ACABB9;
    }
  }

  .caozuo1 {
    text-align: left;

    button {
      width: 128px;
      height: 36px;
      border: none;
      border-radius: 4px;
    }

    & button:nth-child(1) {
      background: #C10B17;
      color: #FFFFFF;
      margin-right: 30px;
    }

    & button:nth-child(2) {
      background: #F0F1F6;
      color: #ACABB9;
    }
  }

  .main1 {
    margin: 0 65px 0 65px;
    padding-bottom: 30px;

    span {
      width: 90px;
    }

    .one {
      text-align: left;
      margin: 20px 0;
      justify-content: space-between;
    }

    .one1 {
      text-align: left;
      margin: 20px 0;
      justify-content: start;

      &>view {
        display: inline-block;
      }

      span {
        display: inline-block;
        width: 90px !important;
      }

      & span:nth-chid(1) {
        display: inline-block;
        width: 90px;
      }
    }
  }

  .headImg {
    width: 70px;
    height: 70px;
    vertical-align: middle;
  }

  .head1 {
    width: 100%;
    height: 54px;
    background: #FAFAFA;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 54px;
    text-align: left;
    text-indent: 25px;
    justify-content: space-between;
  }

  .right {
    width: 893px;
    min-height: 692px;

    border: 1px solid #EDEDED;
    border-radius: 4px;
    margin-left: 24px;
  }

  .left {
    width: 283px;
    height: 692px;
    border: 1px solid #EDEDED;
    border-radius: 4px;

    .tixian {
      width: 70px;
      height: 32px;
      background: #C10B17;
      border-radius: 4px;
      border: none;
      color: #FFFFFF;
    }

    .line2 {
      margin: 45px 32px 25px 32px;
      justify-content: space-between;

      span {
        color: #F9D681;
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #F9D681;
      }
    }

    .line1 {
      margin-top: 27px;
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #333333;

      img {
        width: 70px;
        height: 70px;
        vertical-align: middle;
        margin-right: 11px;
      }
    }
  }

  .hello {
    width: 1300px;
    margin: 40px auto;
    align-items: flex-start;
  }

  .login {
    width: 522px;
    background: #FFFFFF;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -261px;
    margin-top: -278px;
    z-index: 10001;
    box-shadow: 0px 0px 10px 0px rgba(29, 24, 7, 0.05);
    text-align: center;

    .login_main {
      .yzm {
        position: absolute;
        width: 107px;
        height: 37px;
        border: 1px solid #C10B17;
        border-radius: 10px;
        color: #C10B17;
        font-size: 16px;
        background-color: #FFFFFF;
        right: 50px;
      }
    }

    .xieyi {
      text-align: left;
      margin-left: 25px;

      img {
        vertical-align: middle;
        margin-right: 10px;
      }
    }

    .change {
      width: 100%;
      margin: 19px 53px 106px 53px;
      justify-content: space-between;

      span {
        // display: inline-block;
      }

      &>span:nth-child(1) {
        width: 50%;
        color: #C10B17;
        text-align: left;
      }

      &>span:nth-child(2) {
        width: 50%;
        color: #999999;
        // text-align: left;
      }
    }

    input {
      width: 421px;
      height: 50px;
      border: none;
      margin-bottom: 30px;
      border-bottom: 1px solid #E6E6E6;
      outline: none !important;
    }

    .login_btn {
      width: 410px;
      height: 50px;
      background: #C10B17;
      border-radius: 10px;
      color: #FFFFFF;
      font-size: 18px;
    }

    i {
      position: absolute;
      right: 10px;
      top: 10px;
    }

    .logo {
      margin: 30px 0 30px 0;

    }

  }
</style>



// WEBPACK FOOTER //
// src/view/me/switchLogin.vue